import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/globals';
import { AssessmentsService } from 'app/services/assessment/AssessmentsService';
import { RatersService } from 'app/services/rater/RatersService';
import { CryptoJs } from 'app/shared/crypto-js/crypto-js.component';
import { ToastrService } from 'ngx-toastr';
import { isUndefined } from 'util';

@Component({
  selector: 'app-rater-login',
  templateUrl: './rater-login.component.html',
  styleUrls: ['./rater-login.component.scss']
})
export class RaterLoginComponent implements OnInit {

  public currentYear = new Date().getFullYear();
  public user: {email: string, pass: string} = {
    email: null,
    pass: null
  }
  public userType: number;
  public encryptedData: any;
  public assignmentId: number;

  constructor(
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private cryptoJs: CryptoJs,
    private assessmentsService: AssessmentsService,
    private ratersService: RatersService,
    private globals: Globals,
    private router: Router) {

      this.activatedRoute.queryParams.subscribe(params => {
        try {
            console.log('params', params);

            this.userType = Number(params['uj']);
            this.encryptedData = JSON.parse(this.cryptoJs.decrypt(decodeURI(params['rw']), '9s6v9y$B&E!H@McQfTjWnZq4t7w!z%C*'));
            this.user.email = String(this.cryptoJs.decrypt(decodeURI(params['ly']), '9s6v9y$B&E!H@McQfTjWnZq4t7w!z%C*'));

            console.log(this.userType);
            console.log(this.encryptedData);

            if (this.encryptedData.xa < 50) {
                this.assignmentId = this.encryptedData.d1 + this.encryptedData.rd;
            } else if (this.encryptedData.xa >= 50) {
                this.assignmentId = this.encryptedData.rd + this.encryptedData.d1;
            }
            console.log('assignmentId', this.assignmentId);
        } catch (error) {
            this.toastr.warning('Invalid link.', 'ELI' );
            this.router.navigate(['login']);
        }
      });
    }

  ngOnInit() {
  }

  public authenticateRater(form: NgForm): void {
    $('body').css('cursor', 'wait');
    $('.btn').prop('disabled', true);

    console.log('form', form);

    if (!form.value.email || String(form.value.email).trim().length === 0) {
        this.toastr.warning('Email address is requiered.', 'ELI');
        $('body').css('cursor', 'default');
        $('.btn').prop('disabled', false);
        $('#email').focus();
        return;
    }

    if (!form.value.pass || String(form.value.pass).trim().length === 0) {
        this.toastr.warning('Code is required.', 'ELI');
        $('body').css('cursor', 'default');
        $('.btn').prop('disabled', false);
        $('#pass').focus();
        return;
    }

    const code = form.value.pass.trim();
    const email = form.value.email.trim();

    if (!email || !code) {
        if (!email) {
            $('#email').focus();
        } else {
            $('#pass').focus();
        }
        this.toastr.warning('Invalid email or code', 'ELI');
        $('body').css('cursor', 'default');
        $('.btn').prop('disabled', false);
        return;
    }

    const pattern = new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$');
    if (!pattern.test(code) === true) {
        this.toastr.warning('Invalid format code', 'ELI');
        $('body').css('cursor', 'default');
        $('.btn').prop('disabled', false);

        return;
    }

    switch (this.userType) {
      case 1:
          // client taking an assessment from link
          this.assignmentDetailsForActivation(this.assignmentId, encodeURIComponent(code));
          break;
      case 2:
          // rater taking an assessment from link
          this.clientRaterAssignmentDetailsForActivation(this.assignmentId, encodeURIComponent(code));
          break;
    }

    $('body').css('cursor', 'default');
    $('.btn').prop('disabled', false);
  }

  public preventSpace(value: string, event: any) {
    const tagName = event.target.id;

    if (value == null || value === '') {
        if (event.keyCode == 32) {
            return false;
        }
    }
    if (value === ' ') {
        $('#' + tagName).val('');
    }
  }

  // client
  private assignmentDetailsForActivation(assignmentId: number, activationCode: string): void {
    this.assessmentsService.getAssignmentDetailsForActivation(assignmentId, activationCode).subscribe((data: any) => {
        console.log('getAssignmentDetailsForActivation', data);

        switch (data.result.Result) {
            case -3:
                this.globals.assesmentErrorMessage = 'We are sorry. The assessment you are trying to reach has expired.';
                this.router.navigate(['ASSESSMENTERRORPAGE']);
                break;

            case -2:
                this.globals.assesmentErrorMessage = 'We are sorry. The assessment you are trying to reach does not exist anymore in our system. It was probably unassigned by your coach.';
                this.router.navigate(['ASSESSMENTERRORPAGE']);
                break;

            case -1:
                this.globals.assesmentErrorMessage = 'We are sorry. We cannot find the assessment you trying to reach.';
                this.router.navigate(['ASSESSMENTERRORPAGE']);
                break;

            case 0:
                this.globals.assesmentErrorMessage = 'We are sorry. An unexpected error happened while trying to access the request assessment.';
                this.router.navigate(['ASSESSMENTERRORPAGE']);
                break;

            case 1:
                const _data = JSON.parse(this.cryptoJs.decrypt(JSON.parse(data.result.Data), 'Ps6v7y$B&E!H@McKfTjWnZq4t7w!z%8*'));
                console.log('getAssignmentDetailsForActivation', _data);

                let assignmentId: any;
                if (isUndefined(_data.AssignmentId)) {
                    assignmentId = this.assignmentId;
                } else {
                    assignmentId = _data.AssignmentId;
                }

                this.globals.invitationLinkUserId = _data.ClientId;
                this.globals.invitationLinkUserEmail = _data.ClientEmail;
                this.globals.invitationLinkUserName = _data.ClientFirstName;
                this.globals.invitationLinkUserLastName = _data.ClientLastName;
                this.globals.invitationLinkAssessmentId = _data.AssessmentId;
                this.globals.invitationLinkAssignmentId = assignmentId;
                this.globals.invitationLinkAssessmentName = _data.AssessmentName;
                this.globals.invitationLinkLanguage = _data.Language;
                this.globals.invitationLinkFrom = 'pending';
                this.globals.invitacionLinkCompareIds = true;

                switch (_data.UserStatus) {
                    case 1:
                        if (_data.AssignmentStatus == 3) {
                            this.toastr.warning('The assessment you tried to reach has already been completed.', 'ELI', {
                                disableTimeOut: true
                            });
                        } else {
                            if (this.globals.getUserId() == _data.ClientId) {
                                // user is logged in
                                this.router.navigate(
                                    ['/app/assigned_assessment', 'pending', _data.AssessmentId, assignmentId, _data.AssessmentName, _data.Language],
                                    {state: { showBanner: false } });
                            } else {// TODO; change
                                // redirect to login user logged out
                                this.redirectToLogin(assignmentId);
                                return false;
                            }
                        }
                        break;

                    case 2: // redirect to account activation
                        const temporalToken = this.cryptoJs.decrypt(_data.in8, '7s6v7y$B&E!H@McQfTjWnZq4t7w!z%C*');
                        console.log('temporalToken', temporalToken);

                        this.globals.setFullName(this.cryptoJs.encrypt(_data.ClientFirstName, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'), this.cryptoJs.encrypt(_data.ClientLastName, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                        this.globals.setUserId(this.cryptoJs.encrypt(_data.ClientId, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                        this.globals.setUserEmail(this.cryptoJs.encrypt(_data.ClientEmail, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                        this.globals.setToken(temporalToken);
                        this.router.navigate(['/app/account_activaion']);
                        break;
                }

                this.globals.invitacionLinkCompareIds = false;
                break;

            default:
                this.globals.assesmentErrorMessage = 'We are sorry. An unexpected error happened while trying to access the request assessment.';
                this.router.navigate(['ASSESSMENTERRORPAGE']);
        }


    });
  }

// rater
  private clientRaterAssignmentDetailsForActivation(assignmentId: number, activationCode: string): void {
      this.ratersService.getClientRaterAssignmentDetailsForActivation(assignmentId, activationCode).subscribe((response: any) => {
          console.log('_GetClientRaterAssignmentDetails_response', response);

          switch (response.result.Result) {
              case -2:
                  this.globals.assesmentErrorMessage = 'We are sorry. We could not find the requested assessment';
                  this.router.navigate(['ASSESSMENTERRORPAGE']);
                  break;

              case -1:
                  this.globals.assesmentErrorMessage = 'We are sorry, activation code for the assessment is invalid';
                  this.router.navigate(['ASSESSMENTERRORPAGE']);
                  break;

              case 0:
                  this.globals.assesmentErrorMessage = 'We are sorry, an error happened when trying to access the assessment';
                  this.router.navigate(['ASSESSMENTERRORPAGE']);
                  break;

              case 1:
                  const _data = JSON.parse(response.result.Data);
                  console.log(_data);

                  if (_data.AssessmentId == 0) {
                      this.globals.assesmentErrorMessage = 'The specified assessment you are trying to reach is not longer available in our servers.';
                      this.router.navigate(['ASSESSMENTERRORPAGE']);
                      return;
                  }

                  let assignmentId: any;
                  if (isUndefined(_data.AssignmentId)) {
                      assignmentId = this.assignmentId;
                  } else {
                      assignmentId = _data.AssignmentId;
                  }

                  this.globals.setUserId(this.cryptoJs.encrypt(_data.RaterId.toString(), '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                  this.globals.invitationLinkUserId = _data.RaterId;
                  this.globals.invitationLinkUserEmail = _data.RaterEmail;
                  this.globals.invitationLinkUserName = _data.RaterFirstName;
                  this.globals.invitationLinkUserLastName = _data.RaterLastName;
                  this.globals.invitationLinkAssessmentId = _data.AssessmentId;
                  this.globals.invitationLinkAssignmentId = assignmentId;
                  this.globals.invitationLinkAssessmentName = _data.AssessmentName;
                  this.globals.invitationLinkLanguage = _data.Language;
                  this.globals.invitationLinkFrom = 'rater';
                  this.globals.invitacionLinkCompareIds = true;

                  const fullName = `${_data.ClientInfo.FirstName} ${_data.ClientInfo.LastName}`;
                  this.globals.invitationLinkFullName = fullName;

                  if (parseInt(_data.AssignmentId) == 0) {
                      this.globals.toggleMenuWithOutLoggin = true;
                      console.log('Your assessment period has ended.');
                      return;
                  }

                  if (_data.AssignmentStatus == 3) {
                        this.toastr.warning('The assessment you tried to reach has already been completed.', 'ELI', {
                            disableTimeOut: true
                        });

                        this.globals.assessmentCompleted = true;
                        this.globals.userEmail = _data.RaterEmail;
                        console.log('Assessment completed');
                        //   this.globals.clearAllAndRediretToLogin();
                        $('#pass').val('');
                        return;
                      // }
                  } else {
                        this.router.navigate(['/assigned_assessment', 'rater', _data.AssessmentId, assignmentId, _data.AssessmentName, _data.Language, fullName]);
                  }

                  this.globals.invitacionLinkCompareIds = false;
                  break;
          }
      });
  }

  private redirectToLogin(assignmentId: number) {
    this.globals.deleteAllStorage();
    this.globals.invitationLinkAssignmentId = assignmentId;
    this.globals.isClientTakeAssessment = true;
    this.router.navigate(['/login']);
  }

}
